// Importa los estilos

import { Button } from '@mui/material';
import orkestamediaLogo from '../../assets/images/orkestamedia-logo.png';
import { LinkedIn, Phone, Mail } from '@mui/icons-material';
import useStyles from './styles';

const Footer = () => {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <div className={classes.content}>
        {/* Sección de botones */}
        <div className={classes.buttonsDiv}>
          <Button className={classes.buttons} variant="text" href="#plataforma">Plataforma</Button>
          <Button className={classes.buttons} variant="text" href="#acerca-de">Acerca de</Button>
          <Button className={classes.buttons} variant="text" href="#contacto">Contacto</Button>
        </div>

        {/* Sección de logotipos e iconos */}
        <div className={classes.logoDiv}>
          <a href="/">
            <img src={orkestamediaLogo} alt="Orkestamedia logo" className={classes.imgLogos} />
          </a>
          <div className={classes.linksContainer}>
            <a href="https://www.linkedin.com/company/axeleratum1/" target="_blank" rel="noreferrer" className={classes.linkedInButton}>
              <LinkedIn className={classes.linkedinIcon} />
            </a>
            <span>|</span>
            <a href="tel:+525550936536" className={classes.mailLink}>
              <Phone /> (55) 50936536
            </a>
            <span>|</span>
            <a href="mailto:info@axeleratum.com" className={classes.mailLink}>
              <Mail />
              info@axeleratum.com
            </a>
          </div>
        </div>

      </div>

      {/* Línea divisoria */}
      <hr className={classes.divider} />

      {/* Sección de texto inferior */}
      <div className={classes.bottomText}>
        <span className={classes.leftText}>©Axeleratum 2024. Todos los derechos reservados.</span>
        <span className={classes.rightText}><a className={classes.rightText} href='https://www.axeleratum.com/static/media/aviso_privacidad.b9587c2a48b64a058958.pdf' target='_blank' rel="noreferrer">Aviso de privacidad</a></span>
      </div>
    </footer>
  );
};

export default Footer;